import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptionsListStore } from 'src/app/store/options-list-store';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { filter, map, Observable, pipe, switchMap, tap } from 'rxjs';
import { AnswerOptionItem } from 'src/app/models/answerOptionItem.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { OptionsListApiService } from 'src/app/features/collections/services/options-list-api.service';
import { Question } from 'src/app/models/question.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MenuQuestionComponent } from '../menu-question/menu-question.component';
import { AnswerOptionItemInputComponent } from '../autocomplete-question/component/answer-option-item-input/answer-option-item-input.component';
import { DisplayListComponent } from '../autocomplete-question/component/display-list/display-list.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { GlobalStore } from 'src/app/store/global-store';
import { MatDialog } from '@angular/material/dialog';
import { GenericFormArrayComponent } from 'src/app/shared/components/generic-form-array/generic-form-array.component';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { GlobalService } from 'src/app/shared/services/global-service';
import { UuidService } from 'src/app/services/uuid.service';
import { MessagePopupComponent } from '../autocomplete-question/component/answer-option-item-input/message-popup/message-popup.component';
import { DragStore } from 'src/app/store/drag-store';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-mark-question',
    imports: [CommonModule, DisplayListComponent, AnswerOptionItemInputComponent, MatCheckboxModule,
        MenuQuestionComponent, ReactiveFormsModule, TranslateDirective, TranslatePipe, GenericFormArrayComponent, OverlayModule],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: MarkQuestionComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: MarkQuestionComponent,
            multi: true
        }
    ],
    templateUrl: './mark-question.component.html',
    styleUrls: ['./mark-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarkQuestionComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() index?: number;
  @Output() focusEvent = new EventEmitter<boolean>();
  #globalStore = inject(GlobalStore);
  #builder = inject(FormBuilder);
  #dialog = inject(MatDialog);
  #dragStore = inject(DragStore);
  #globalService = inject(GlobalService);
  #uuidService = inject(UuidService);
  readonly positonArea = [{
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
  }] as ConnectedPosition[];
  #optionsListApiService$ = inject(OptionsListApiService);
  allOptionLists$ = toSignal(this.#globalStore.optionLists$);
  question?: Question;
  // defaultItemToAdd={ id: 0, name: "", optionsListId: this.listForm.controls.id.value } as AnswerOptionItem
  newOption = this.#globalService.getDefaulteNewOption();

  listForm = this.#builder.group({
    guid: new FormControl<string>('', [Validators.required]),
    // name: new FormControl<string>("רשימות שנשמרו", [Validators.required]),
    // title: new FormControl<String>('', [Validators.required]),
    // placeholder: new FormControl<String>("", [Validators.required]),
    // answerOptionItem: this.#builder.array<AnswerOptionItem>([]),
    answerOptionItem: new FormControl<AnswerOptionItem[]>([]),
    isPublic: new FormControl<boolean>(false),
  });
  requierd = new FormControl<boolean>(false);
  collectionQuestionId = new FormControl<number | null>(null);

  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;
  publicListId = new FormControl<string | null>('');
  isSelectOpen = false;
  selectedTypeName = "";
  constructor() {
    this.publicListId.valueChanges.pipe(filter(id => id != null),
      switchMap(guid => {
        return this.#optionsListApiService$.getItemsByListId(guid ?? '')
      })).subscribe((x) => {
        this.listForm.setValue({ guid: this.publicListId.value, isPublic: true, answerOptionItem: x })
      }
      );
  }
  ngOnInit(): void {
    this.listForm.valueChanges.subscribe(list => {
      {
        return this.registerOnChangeCallback({ ...this.question, requierd: this.requierd.value, optionsList: { ...list, name: this.selectedTypeName } } as Question);
      }
    });
    this.requierd.valueChanges.subscribe(requierd => {
      this.registerOnChangeCallback({ ...this.question, requierd: requierd, optionsList: { ...this.listForm.value, name: this.selectedTypeName } } as Question);
    });
    //אפשר לחבר אותם עם combine....
  }
  // addOptionToArray() {
  //   this.listForm.controls.answerOptionItem.push(new FormControl<AnswerOptionItem>({ id: 0, name: "", optionsListId: this.listForm.controls.id.value } as AnswerOptionItem))
  //   // this.listForm.controls.answerOptionItem.push(new FormControl<AnswerOptionItem>("ללא ערך"))
  // }
  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.listForm.valid) {
      return null;
    }
    return { 'listForm': "not-valid" }
  }
  writeValue(obj: Question): void {
    this.question = obj;
    this.requierd.setValue(obj.requierd ?? false, { emitEvent: false })
    this.collectionQuestionId.setValue(obj.collectionQuestionId ?? null, { emitEvent: false })
    this.listForm.patchValue({ ...obj.optionsList }, { emitEvent: false });
    // if (obj.optionsList && obj.optionsList.answerOptionItem)
    //   obj.optionsList.answerOptionItem.forEach(op => this.listForm.controls.answerOptionItem.push(new FormControl<AnswerOptionItem>(op)))
    if (obj.optionsList?.isPublic == true) {
      if (obj.optionsList?.name)
        this.selectedTypeName = obj.optionsList?.name;
      this.publicListId.setValue(obj.optionsList.guid, { emitEvent: false });
    }
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  // deleteOp(index: number) {
  //   this.listForm.controls.answerOptionItem.removeAt(index)
  // }

  updateSelection(op: OptionsList) {
    if (this.listForm.value.answerOptionItem?.some(ans => ans.followQuestionChildsIdes?.length ?? 0 > 0)) {
      this.#dialog.open(MessagePopupComponent, { data: { message: "delete all??" } }).afterClosed().subscribe(
        x => {
          if (x) {
            //delete all
            this.#dragStore.deleteFollowQuestionsByIds({ optionGuid: "none", questionIdes: this.listForm.value.answerOptionItem?.flatMap(ans => ans?.followQuestionChildsIdes ?? []) ?? [] })
            this.publicListId.setValue(op.guid);
            this.selectedTypeName = op.name ?? "";
            this.isSelectOpen = false;
          } else {

            this.isSelectOpen = false;
          }
        }
      );
    } else {
      this.publicListId.setValue(op.guid);
      this.selectedTypeName = op.name ?? "";
      this.isSelectOpen = false;
    }
  }
  selectWithout() {
    if (this.listForm.value.answerOptionItem?.some(ans => ans.followQuestionChildsIdes?.length ?? 0 > 0)) {
      this.#dialog.open(MessagePopupComponent, { data: { message: "delete all??" } }).afterClosed().subscribe(
        x => {
          if (x) {
            //delete all
            this.#dragStore.deleteFollowQuestionsByIds({ optionGuid: "none", questionIdes: this.listForm.value.answerOptionItem?.flatMap(ans => ans?.followQuestionChildsIdes ?? []) ?? [] });
            var listGuid = this.#uuidService.generateUUID();
            this.listForm.setValue({ guid: listGuid, isPublic: false, answerOptionItem: [{ guid: this.#uuidService.generateUUID(), name: '', optionsListGuid: listGuid }] })
            this.publicListId.setValue(null);
            this.selectedTypeName = '';
            this.isSelectOpen = false;
          }
          else {
            this.isSelectOpen = false;
          }
        }
      );
    } else {
      var listGuid = this.#uuidService.generateUUID();
      this.listForm.setValue({ guid: listGuid, isPublic: false, answerOptionItem: [{ guid: this.#uuidService.generateUUID(), name: '', optionsListGuid: listGuid }] })
      this.publicListId.setValue(null);
      this.selectedTypeName = '';
      this.isSelectOpen = false;
    }
  }
  newItem() {
    return { guid: this.#uuidService.generateUUID(), name: '', optionsListGuid: this.listForm.controls.guid.value };
  }
}
